import { useTranslation } from 'react-i18next'

import { StorefrontIcon, UserCircleIcon } from '@phosphor-icons/react'

import { FormatPrice, Text } from '@reveni-io/reveni-ui'

import OrderItemDate from '@/returns/components/OrderItemDate/OrderItemDate'

import * as Styles from './styles'

const Order = ({ info, onViewOrder }) => {
  const { t, i18n } = useTranslation()

  return (
    <Styles.Container onClick={() => onViewOrder({ orderName: info.name, customerEmail: info.customer_email })}>
      <Styles.Header>
        <Text type="titleM">{info?.name}</Text>
      </Styles.Header>
      <Styles.BodyContainer>
        <Styles.LeftSection>
          <Styles.UserInfo>
            <UserCircleIcon size={24} weight="light" />
            <Text type="bodyMRegular">{info?.customer_name}</Text>·
            <Text type="bodyMRegular">{info?.customer_email}</Text>
          </Styles.UserInfo>
          <OrderItemDate language={i18n.language} completedAt={info?.order_date} />
        </Styles.LeftSection>
        <Styles.RightSection>
          <Styles.StoreInfo>
            <StorefrontIcon size={24} weight="light" />
            <Text type="bodyMRegular">{info?.store_name}</Text>
          </Styles.StoreInfo>
          <Styles.OrderPriceContainer>
            <Text type="bodyMRegular">
              {info?.product_count} {t(info?.product_count > 1 ? 'productos' : 'producto')} |
            </Text>
            <Text type="titleS">
              <FormatPrice currency={info?.currency}>{info?.total_amount}</FormatPrice>
            </Text>
          </Styles.OrderPriceContainer>
        </Styles.RightSection>
      </Styles.BodyContainer>
    </Styles.Container>
  )
}

export default Order
